<script>
import appConfig from "@/app.config";
import Layout from "@/layouts/main.vue";
import HelpSupport from "@/components/HelpSupport.vue";
import CategoryNavSlider from "@/components/CategoryNavSlider.vue";
import BlogCard from "@/components/BlogCard.vue";
// import GameTvSlider from "@/components/GameTvSlider/index.vue";

export default {
  page: {
    title: "Learn & Play",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    BlogCard,
    HelpSupport,
    CategoryNavSlider,
    // GameTvSlider,
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
      showLoadingScreen: true,
      pageData: {},
      gamesSlideData: [
        {
          image: "CreamTruck2_1@2x.jpg",
        },
        {
          image: "CreamTruck2_4@2x.jpg",
        },
        {
          image: "CreamTruck2_2@2x.jpg",
        },
        {
          image: "CreamTruck2_5@2x.jpg",
        },
        {
          image: "CreamTruck2_3@2x.jpg",
        },
        {
          image: "CreamTruck2_6@2x.jpg",
        },
      ],
      categories: [],
      /** 分类的blog列表，第一类是所有 */
      categoriesBlog: [[]],
      featuredBlog: [
      ],
      blogs: [
        {
          category: "Culture",
          title: "Tips for creating a culture of diversity",
          image: "bold-image-3@2x.jpg",
          colorClass: "color-green",
        },
        {
          category: "Playful Activity",
          title: "How to win over skeptics with qualitative research",
          image: "bold-image-4@2x.jpg",
          colorClass: "color-danger",
        },
        {
          category: "Children",
          title: "Why your design team should hire a writer",
          image: "bold-image-5@2x.jpg",
          colorClass: "color-skyblue",
        },
      ],
      extraBlogs: [
        {
          category: "Brand",
          title: "When building new products goes wrong",
          image: "bold-image-6@2x.jpg",
          colorClass: "color-green",
        },
        {
          category: "Culture",
          title: "New features help you manage work and home",
          image: "bold-image-7@2x.jpg",
          colorClass: "color-pink",
        },
        {
          category: "Education",
          title: "Creating a sense of community amidst COVID-19",
          image: "bold-image-8@2x.jpg",
          colorClass: "color-info",
        },
      ],
      swiperOption: {
        speed: 1500,
        slidesPerView: 4,
        centeredSlides: true,
        spaceBetween: 40,
        grabCursor: true,
        //loop: true,

        slidesPerGroup: 1,
        loopFillGroupWithBlank: true,
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false,
        // },

        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },

        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
      },
    };
  },
  methods: {
    languageChanged(value) {
      const data = this.pageData.data[value];
      const { categories } = data;
      this.categories = categories;
      let featuredBlog = [];
      for (let i = data.list.length - 1; i >= 0; i--) {
        const categorie = JSON.parse(data.list[i].categorie);
        const categorieData = categories[categorie.id];
        const postCard = {
          category: categorieData.text,
          title: data.list[i].title,
          image: data.list[i].image,
          route: data.list[i].route,
          colorClass: `color: ${categorieData.color || "#2e1ce8"};`,
          isHide: data.list[i].isHide,
        };
        this.categoriesBlog[0].push(postCard);
        if (this.categoriesBlog[categorie.id + 1]) {
          this.categoriesBlog[categorie.id + 1].push(postCard);
        } else {
          this.categoriesBlog[categorie.id + 1] = [postCard];
        }
        featuredBlog.push(postCard);
      }
      this.featuredBlog = featuredBlog.filter((el) => !el.isHide);
    },
    slideTo(index) {
      console.warn("slideTo", index);
      this.featuredBlog = this.categoriesBlog[index];
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 300);
    },
  },
  created: function () {
    this.GLOBAL.addEventListener("languageChanged", this.languageChanged);
    this.pageData = window.pageData;
  },
  mounted() {
    this.scrollToTop();
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.scrollToTop();
        this.showLoadingScreen = false;
      }
    };
  },
};
</script>

<template>
  <Layout headerStyle="headerDark" :showLoadingScreen="showLoadingScreen">
    <div class="bg-offWhite d-inline-block w-100">
      <div :class="$style.homeHero" class="d-flex">
        <img
          :src="assetsPath + 'images/skye-background@2x.jpg'"
          alt=""
          class="fit-cover"
        />
        <CategoryNavSlider :categories="categories" :slideTo="slideTo" />
      </div>
    </div>

    <div
      :class="$style.blogBlock"
      class="d-flex flex-column w-100 bg-lightYellow"
    >
      <b-container>
        <div :class="$style.setOnTop">
          <b-row>
            <b-col
              v-for="(blog, index) in featuredBlog"
              :key="index"
              cols="12"
              md="6"
              class="mb-4"
            >
              <BlogCard :blog="blog" class="mb-3" />
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>

    <!-- <div
      :class="$style.gamesTvBlock"
      class="d-flex flex-column w-100 block-py-20"
    >
      <div :class="$style.slider" class="w-100">
        <GameTvSlider />
      </div>
      <b-container>
        <div
          class="d-flex d-md-none justify-content-center align-items-center"
          :class="$style.yellowBtn"
        >
          <button class="btn btn-yellow rounded-half btn-x w-100">
            More Videos
          </button>
        </div>
      </b-container>
    </div> -->

    <!-- <div
      :class="$style.blogBottomBlock"
      class="d-flex flex-column w-100 bg-lightYellow"
    >
      <b-container>
        <b-row>
          <b-col
            v-for="(blog, index) in extraBlogs"
            :key="index"
            cols="12"
            md="4"
          >
            <div :class="$style.singleCard">
              <BlogCard :blog="blog" />
            </div>
          </b-col>
        </b-row>
        <div
          class="d-flex flex-row align-items-center justify-content-center"
          :class="$style.showMore"
        >
          <button type="button" class="btn btn-primary btn-x">Show More</button>
        </div>
      </b-container>
    </div> -->

    <div class="w-100 d-inline-block">
      <HelpSupport />
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.homeHero {
  position: relative;
  height: 500px;
}
.blogBlock {
  padding-bottom: 120px;
  .setOnTop {
    margin-top: -135px;
  }
}
.gamesTvBlock {
  background-color: $dark-blue;
}
.blogBottomBlock {
  padding-top: 120px;
  padding-bottom: 107px;
  .showMore {
    margin-top: 74px;
  }
}
@media only screen and (max-width: 767px) {
  .homeHero {
    height: 300px;
  }
  .blogBlock {
    .setOnTop {
      margin-top: -76px;
    }
  }
  .singleCard {
    margin-bottom: 30px;
  }
  .gamesTvBlock {
    padding-top: 80px;
    padding-bottom: 72px;
    .slider {
      padding-left: 0;
    }
  }
  .yellowBtn {
    margin-top: 40px;
  }
  .blogBottomBlock {
    padding-top: 80px;
    .showMore {
      margin-top: 0;
    }
  }
}
</style>